import { render, staticRenderFns } from "./duzyaziinput.vue?vue&type=template&id=9e89304e&scoped=true&"
import script from "./duzyaziinput.vue?vue&type=script&lang=js&"
export * from "./duzyaziinput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e89304e",
  null
  
)

export default component.exports